/* eslint-disable camelcase */
import React, { createContext, useEffect, useState } from 'react'
import api from '../services/api'
import axios from 'axios'

interface BaseDataProps {
  id?: string
  base: string
  outpost: string
  Address: [
    {
      id: string
      address: string
      zipcode: string
      burgh: string
      city: string
      state: string
      latitude: number
      longitude: number
    },
  ]
}

interface Istate {
  id: string
  value: string
}

type IBaseProps = {
  baseList: BaseDataProps
  formData?: BaseDataProps
  handleFormSubmit?: (event: React.FormEvent) => void
  handleChange?: (event: React.FormEvent) => void
  handleEditSubmit?: (event: React.FormEvent) => void
  setFormData?: React.Dispatch<React.SetStateAction<BaseDataProps | null>>
  states: Istate[]
  isFormDataValid?: (
    confirm: React.Dispatch<React.SetStateAction<boolean>>,
  ) => void
  maskCEP: (value: string) => string
}

interface IAddres {
  logradouro: string
  cep: string
  bairro: string
  localidade: string
  uf: string
}

export const BaseContext = createContext<IBaseProps>()

const ContextBaseProvider = (props) => {
  const [baseList, setBaseList] = useState<BaseDataProps[]>([])
  const [addressData, setAddressData] = useState<IAddres>()

  const [formData, setFormData] = useState<BaseDataProps>({
    base: '',
    outpost: '',
    Address: [
      {
        id: '',
        address: addressData?.logradouro || '',
        zipcode: addressData?.cep || '',
        burgh: addressData?.bairro || '',
        city: addressData?.localidade || '',
        state: addressData?.uf || '',
        latitude: 0,
        longitude: 0,
      },
    ],
  })

  const maskCEP = (value) => {
    return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
  }

  console.log('🚀 ~ ContextBaseProvider ~ addressData:', addressData)

  const states = [
    { id: 'AC', value: 'Acre' },
    { id: 'AL', value: 'Alagoas' },
    { id: 'AP', value: 'Amapá' },
    { id: 'AM', value: 'Amazonas' },
    { id: 'BA', value: 'Bahia' },
    { id: 'CE', value: 'Ceará' },
    { id: 'DF', value: 'Distrito Federal' },
    { id: 'ES', value: 'Espírito Santo' },
    { id: 'GO', value: 'Goiás' },
    { id: 'MA', value: 'Maranhão' },
    { id: 'MT', value: 'Mato Grosso' },
    { id: 'MS', value: 'Mato Grosso do Sul' },
    { id: 'MG', value: 'Minas Gerais' },
    { id: 'PA', value: 'Pará' },
    { id: 'PB', value: 'Paraíba' },
    { id: 'PR', value: 'Paraná' },
    { id: 'PE', value: 'Pernambuco' },
    { id: 'PI', value: 'Piauí' },
    { id: 'RJ', value: 'Rio de Janeiro' },
    { id: 'RN', value: 'Rio Grande do Norte' },
    { id: 'RS', value: 'Rio Grande do Sul' },
    { id: 'RO', value: 'Rondônia' },
    { id: 'RR', value: 'Roraima' },
    { id: 'SC', value: 'Santa Catarina' },
    { id: 'SP', value: 'São Paulo' },
    { id: 'SE', value: 'Sergipe' },
    { id: 'TO', value: 'Tocantins' },
  ]

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    const { base, outpost, Address } = formData

    try {
      api.post('/v1/dashboard/base/create', { base, outpost, Address })
      console.log('dados enviados', { base, outpost, Address })
    } catch (err) {
      console.error('Erro ao enviar dados:', err.response.data)
      if (err.response && err.response.data) {
        console.error('Server error message:', err.response.data)
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setFormData((prev) => ({
      ...prev,
      Address: [
        {
          ...prev.Address[0],
          [name]: value,
        },
      ],
    }))
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()

    try {
      await api.put('/v1/dashboard/base/update', formData)
    } catch (error) {
      console.error('Erro ao atualizar:', error)
    }
  }

  const isFormDataValid = (
    confirm: React.Dispatch<React.SetStateAction<boolean>>,
  ): void => {
    const { Address, base, outpost } = formData

    if (!Address || !base || !outpost) {
      console.log('Algum campo obrigatório está vazio', {
        Address,
        base,
        outpost,
      })
      return
    }

    console.log('Todos os campos obrigatórios estão preenchidos')
    confirm((prev) => !prev)
  }

  useEffect(() => {
    api
      .get('/v1/dashboard/base/list')
      .then((res) => {
        console.log(
          '🚀 ~ file: context_baseRegister.tsx:129 ~ .then ~ res:',
          res.data,
        )
        setBaseList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    console.log('submit', formData)
  }, [formData])

  return (
    <BaseContext.Provider
      value={{
        baseList,
        formData,
        handleFormSubmit,
        setFormData,
        states,
        handleChange,
        handleEditSubmit,
        isFormDataValid,
        maskCEP,
      }}
    >
      {props.children}
    </BaseContext.Provider>
  )
}

export default ContextBaseProvider
